/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigViewRequest extends models.ServiceNowCmdbConfigBaseRequest {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigViewRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigViewRequest>): ServiceNowCmdbConfigViewRequest {
        let obj = Object.assign(new ServiceNowCmdbConfigViewRequest(), model);
        ServiceNowCmdbConfigViewRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigViewRequest>): ServiceNowCmdbConfigViewRequest {
        if (!model) return null;
        return ServiceNowCmdbConfigViewRequest.newInstance(<ServiceNowCmdbConfigViewRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigViewRequest) {
        if (!obj) return;

        models.ServiceNowCmdbConfigViewRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigViewRequest): boolean {
        if (models.ServiceNowCmdbConfigBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigViewRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Id of the ServiceNow Account in Corestack
     */
    cmdb_account_id: string;

}
